// Ported from LC2's NotifyIssueBySlack (commons/utils/messagingUtils.js) — shown by every
// Glance sub-tab whenever it has no rows for the current scope. Same `notifyIssueBySlack`
// mutation payload (team_member email, issue_type, issue_description, account_sfid/
// community_sfid from the route) already wired into this app's coreApiSlice.js.
import React from 'react';
import PropTypes from 'prop-types';
import {useParams} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {Button, Stack, Typography} from '@mui/material';

import {useNotifyIssueBySlackMutation} from '../../../features/coreApi/apiSlice';
import {getEmail} from '../../../app/store/reducers/session';

const GlanceEmptyState = ({msg, type}) => {
    const params = useParams();
    const email = useSelector(getEmail);
    const [sendNotifyIssueBySlack] = useNotifyIssueBySlackMutation();

    const handleClick = () => {
        sendNotifyIssueBySlack({
            team_member: email,
            issue_type: type,
            issue_description: msg,
            account_sfid: params?.account_sfid,
            building_sfid: params?.community_sfid
        });
    };

    return (
        <Stack direction="column" rowGap={1} sx={{height: 200, justifyContent: 'center', alignItems: 'center'}}>
            <Stack direction="column" sx={{textAlign: 'center'}}>
                <Typography color="text.secondary">{msg}.</Typography>
                <Typography color="text.secondary">
                    If you believe this is an error, please notify the support team by clicking the button below.
                </Typography>
            </Stack>
            <Button variant="text" color="secondary" onClick={handleClick}>
                Flag an issue
            </Button>
        </Stack>
    );
};

GlanceEmptyState.propTypes = {
    msg: PropTypes.string.isRequired,
    type: PropTypes.string
};

export default GlanceEmptyState;
